import { render } from "./LoadingError.vue?vue&type=template&id=5ffa4610&ts=true"
import script from "./LoadingError.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoadingError.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/components/LoadingError.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ffa4610"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ffa4610', __exports__)) {
    api.reload('5ffa4610', __exports__)
  }
  
  module.hot.accept("./LoadingError.vue?vue&type=template&id=5ffa4610&ts=true", () => {
    api.rerender('5ffa4610', render)
  })

}


export default __exports__